<template>
  <cl-breadcrumbs-v2>
    <cl-breadcrumbs-item
      v-for="(item, index) in visibleItems"
      :key="item.url || index"
      :is-link="Boolean(item.url)"
      :test-id="`breadcrumbs-item-${index}`"
      data-clarity-mask="true"
    >
      <template v-if="item.isCollapsed">
        <div
          class="tw-relative tw-inline-flex tw-items-center tw-align-middle"
          tabindex="0"
          @focusout="onBlurCollapse"
        >
          <button
            class="tw-inline-flex tw-items-center tw-gap-1 tw-text-sm tw-bg-transparent tw-border-0 tw-p-0 tw-m-0 tw-h-auto tw-leading-none tw-text-primary-grey-700 tw-no-underline tw-font-normal hover:tw-text-primary-grey-950"
            type="button"
            aria-label="Show hidden breadcrumbs"
            @click="isCollapsedOpen = !isCollapsedOpen"
          >
            …
          </button>
          <div
            v-if="isCollapsedOpen"
            class="tw-absolute tw-top-full tw-left-0 tw-mt-1 tw-z-10 tw-bg-white tw-border tw-border-primary-grey-100 tw-rounded tw-shadow-sm tw-min-w-[10rem] tw-max-w-[22rem]"
          >
            <a
              v-for="(hidden, hIdx) in hiddenItems"
              :key="hidden.url || hIdx"
              class="tw-block tw-w-full tw-text-left tw-px-3 tw-py-2 hover:tw-bg-primary-grey-100 tw-text-primary-grey-700 tw-text-base tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis"
              :href="hidden.url"
              @click.prevent="() => onHiddenClick(hidden)"
            >
              <span v-if="hIdx > 0" class="tw-text-primary-grey-700">/ </span
              >{{ hidden.name }}
            </a>
          </div>
        </div>
      </template>
      <template v-else>
        <router-link
          custom
          v-slot="{ href, navigate }"
          :to="item.url"
          v-if="Boolean(item.url)"
        >
          <a
            :href="href"
            @click="navigate"
            class="tw-text-primary-grey-700 tw-text-base tw-font-normal hover:tw-text-primary-grey-950 hover:tw-underline"
          >
            {{ item.name }}
          </a>
        </router-link>
        <div
          v-else
          class="tw-font-semibold tw-text-base tw-text-primary-grey-950"
        >
          {{ item.name }}
        </div>
      </template>
    </cl-breadcrumbs-item>
  </cl-breadcrumbs-v2>
</template>

<script setup lang="ts">
import { useBreadcrumbs } from "./useBreadcrumbs";
import { useFlag } from "@/composables/useFlags/useFlag.ts";

const { isFeatureAvailable: isDashboardAvailableCustomer } = useFlag(
  "DASHBOARD_OVERVIEW_CUSTOMER",
);

const {
  visibleItems,
  hiddenItems,
  isCollapsedOpen,
  onHiddenClick,
  onBlurCollapse,
} = useBreadcrumbs(isDashboardAvailableCustomer.value);
</script>
